import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'v1/components/shared';
import { useRestrictedAccess } from 'lib/restrictedAccess';
import classnames from 'classnames';
import './EmptyGeneric.scss';
import { maybe } from '@passionware/monads';

const EmptyGenericAction = ({
  text,
  capability,
  allowed: forceAllowed,
  ...rest
}) => {
  const allowed = useRestrictedAccess(undefined, capability, undefined);
  if (maybe.isPresent(forceAllowed)) {
    if (!forceAllowed) {
      return null;
    }
  } else {
    if (!allowed) return null;
  }

  return (
    <div className="EmptyGeneric-action">
      <Button {...rest}>{text}</Button>
    </div>
  );
};

const EmptyGeneric = ({
  description,
  title,
  iconWidth,
  icon,
  action,
  className
}) => (
  <div
    className={classnames(['EmptyGeneric text-center', className])}
    data-id="empty-generic"
  >
    {icon && (
      <img
        className="stack-M m-auto"
        src={icon}
        width={iconWidth || '40px'}
        alt=""
      />
    )}
    <div className="EmptyGeneric-text stack-M">
      <h5>{title}</h5>
      {description && <p>{description}</p>}
    </div>
    {action && <EmptyGenericAction {...action} />}
  </div>
);

EmptyGeneric.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  iconWidth: PropTypes.string, // E.g. '40px'
  icon: PropTypes.string, // Icon img src, eg '/images/icon_colour_contact_notes.svg'
  action: PropTypes.shape({
    text: PropTypes.string // Button text
    // ...rest are Button props
  })
};

export default EmptyGeneric;
